
/**
 * Utility functions for date and time formatting
 */

export const formatDateTime = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString();
};
